import { format } from 'date-fns';

export function dateToIsoWeek(date: Date | string): string {
  return format(date, "RRRR-'W'II");
}
